import type { FunctionComponent } from 'react'

import { useExternalScript } from '@dreamstack/feature-components/src/hooks/useExternalScript'

// declare global {
//   // eslint-disable-next-line @typescript-eslint/no-namespace
//   namespace JSX {
//     interface IntrinsicElements {
//       'hypofriend-calculator': {
//         'property-price'?: number | null
//         'down-payment'?: number | null
//         commission?: number | null
//         locale: string
//         postcode?: string | null
//         children?: ReactNode
//       }
//     }
//   }
// }

const HYPO_FRIEND_SCRIPT_ID = 'hypofriend-script'

export const HypoFriendWidget: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  useExternalScript(
    'https://hypofriend.de/widgets/js/app.js',
    HYPO_FRIEND_SCRIPT_ID
  )

  return (
    <div className="w-full m-auto">
      {/* @ts-expect-error - HypoFriendWidget is a custom element */}
      <hypofriend-calculator
        locale="en"
        property-price={200000}
        down-payment={2000}
        commission={2}
        postcode={'10115'}
      />
    </div>
  )
}
